// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce515196","239":"4af56076","455":"524fece8"}[chunkId] + ".chunk.js";
};